import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/shared/services/common.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
import { constants } from "src/app/shared/common/contants";
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
//  @author Kameshwar
//  @date 09-10-2024
interface ObjectGroup {
  objectGroupId: number;
  objectGroupName: string;
}

@Component({
    selector: 'app-import-dialog',
    templateUrl: './import-dialog.component.html',
    styleUrls: ['./import-dialog.component.scss'],
    standalone: false
})
export class ImportDialogComponent implements OnInit {
  objectGroupNames: ObjectGroup[] = [];
  selectedObjectGroup?: number;
  files: File[] = [];
  validFolder: boolean = true;
  backgroundColorButton = "";
  uploadedFolderName: string = ''; 
  rowData: any;
  columnDefs;
  components: any;
  rowSelection;
  paginationPageSize;
  backgroundColorScreen = "";
  buttonColor = "";
  defaultColDef;
  rowClassRules;
  rowbindingdata;
  lastpage;
  currentpage;
  nextpage;
  nextpageplusone;
  totalpages;
  paginationNumberFormatter;
  ngModelObjectDivision = [];
  ngModelObject = [];
  tableName = "";
  dynamicData = [];
  retrieveObject: any = [];
  grid;
  objectData: any = [];
  datasetobjectattributes: [];
  pagesiz;
  pagesize;
  rowdata: any = [];
  editmode: boolean = false;
  gridApi;
  pageSize;
  reportCreationData: any = [];
  headerNameHtml = "";
  validation_messages;
  deleteData: any = [];
  groupName: any;
  objectGroupData: any = [];
  status: any;
  value;
  previousFiles: any;
  
 
  // reportCreationData={"description":"", "groupname":"",objectid: []}


  constructor(
    public dialogRef: MatDialogRef<ImportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonservice: CommonService,
    private spinner: NgxUiLoaderService,
    private constants: constants,
    private snackbar: MatSnackBar,
    private localStorageSettings:LocalStorageSettingsService,
 
    
  ) {
    this.objectGroupNames = data.ObjectGroups;
  }

  ngOnInit(): void {
    this.columnDefs = [
      {
        headerName: "Import ID",
        headerTooltip: "Import ID",
        tooltipValueGetter: (params) => "Import ID : " + params.value,
        field: "importId",
        filter: "agTextColumnFilter",
        width: 110,
        suppressSizeToFit: true,
      },
      {
        headerName: "Status",
        headerTooltip: "Status",
        tooltipValueGetter: (params) => "Status : " + params.value,
        field: "status",
        filter: "agTextColumnFilter",
        width: 150,
      },
      {
        headerName: 'Object Group Name',
        headerTooltip: "Object Group Name",
        tooltipValueGetter: (params) => "Object Group Name : " + params.value,
        field: 'objectGroupName',
        filter: "agTextColumnFilter",
        width: 150,
      },
      {
        headerName: 'Source Datasets Count',
        headerTooltip: "Source Datasets Count",
        tooltipValueGetter: (params) => "Source Datasets Count : " + params.value,
        field: 'sourceDatasetsCount',
        filter: "agTextColumnFilter",
        width: 150,
      },
      {
        headerName: 'Source Reports Count',
        headerTooltip: "Source Reports Count",
        tooltipValueGetter: (params) => "Source Reports Count : " + params.value,
        field: 'sourceReportsCount',
        filter: "agTextColumnFilter",
        width: 150,
      },
      {
        headerName: 'Imported Datasets Count',
        headerTooltip: "Imported Datasets Count",
        tooltipValueGetter: (params) => "Imported Datasets Count : " + params.value,
        field: 'importedDatasetsCount',
        filter: "agTextColumnFilter",
        width: 150,
      },
      {
        headerName: 'Imported Reports Count',
        headerTooltip: "Imported Reports Count",
        tooltipValueGetter: (params) => "Imported Reports Count : " + params.value,
        field: 'importedReportsCount',
        filter: "agTextColumnFilter",
        width: 150,
      },
      {
        headerName: 'Remarks',
        headerTooltip: "Remarks",
        tooltipValueGetter: (params) => "Remarks : " + params.value,
        field: 'remarks',
        filter: "agTextColumnFilter",
        width: 500,
      }
    ];
  
    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true,
    };
    this.rowSelection = this.constants.rowselection;
    console.log(this.constants.pagesize)
    this.paginationPageSize = 10;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };
    this.backgroundColorScreen =
      this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
  }

  onPaginationChanged() {
    if (this.gridApi) {
      this.lastpage = this.gridApi.paginationIsLastPageFound();

      this.currentpage = this.gridApi.paginationGetCurrentPage() + 1;

      this.nextpage = this.gridApi.paginationGetCurrentPage() + 1 + 1;

      this.nextpageplusone =
        this.gridApi.paginationGetCurrentPage() + 1 + 1 + 1;

      this.totalpages = this.gridApi.paginationGetTotalPages();
    }
  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {
    this.gridApi.paginationGoToPage(searchValue - 1);
  }

  
      // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {
    this.rowbindingdata.api.setGridOption('paginationPageSize', Number(newPageSize));
    
  }


refreshRun(){
  console.log("Inside the refreshmethod");
    this.spinner.start();
    this.onGridReady(this.rowbindingdata);
    this.spinner.stop();

}
 
  onBtFirst() {
    // Implementation for first page button
    this.rowbindingdata.api.paginationGoToFirstPage();
  }

  onBtPrevious() {
    // Implementation for previous page button
    this.rowbindingdata.api.paginationGoToPreviousPage();
  }

  onBtNext() {
    // Implementation for next page button
    this.rowbindingdata.api.paginationGoToNextPage();
  }

  onBtLast() {
    // Implementation for last page button
    this.rowbindingdata.api.paginationGoToLastPage();
  }

  onPaginationChangedReturn() {
    // Implementation for pagination changed event
   // this.rowbindingdata.api.
  }


  // onGridReady(event: any) {
  //   console.log('Fetching data from API');
  //   this.commonservice.retrieveImportHistory(1).subscribe(
  //     data => {
  //       this.rowData = data;
  //        // Set the fetched data to rowData
  //        console.log(this.rowData)
  //     },
  //     error => {
  //       console.error('Error fetching data', error);
  //     }
  //   );
  // }
  async onGridReady(params) {
   
    let dnsId = this.localStorageSettings.getSettings("dnsName")
    console.log(dnsId)
    this.rowbindingdata = params;
    this.commonservice.retrieveImportHistory(dnsId).subscribe((res) => {
      console.log(res);
      this.objectData = res;
      console.log("Successfully");
      this.grid = params;
      console.log(params);
      this.gridApi = params.api;
      console.log(params.api);
      this.grid.api.setGridOption('rowData', this.objectData);
    });
    this.spinner.stop();
  }
  rowDoubleClicked(event: any) {
    // Implementation for row double click event
  }
  clear() {
    // Implementation for row double click event
  }
  close() {
    this.dialogRef.close();
  }

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.files = Array.from(input.files);
      
      // Check for valid file types
      const allowedExtensions = ['.xlsx', '.xls', '.csv', '.pdf'];
      const allFilesValid = this.files.every(file => {
        const extension = file.name.slice((file.name.lastIndexOf(".")));
        return allowedExtensions.includes(extension.toLowerCase());
      });
  
      this.validFolder = this.files.length > 0 && allFilesValid;
  
      if (!this.validFolder) {
        const invalidFiles = this.files.filter(file => {
          const extension = file.name.slice((file.name.lastIndexOf(".")));
          return !allowedExtensions.includes(extension.toLowerCase());
        });
  
        // Clear the files array
        this.files = [];
  
        this.snackbar.open(`The file "${invalidFiles[0].name}" is not a valid type. Please upload files with one of the following extensions: .xlsx, .xls, .csv, or .pdf.`, "OK", { duration: 5000 });
      }
      if (this.files.length > 0) {
        const firstFile = this.files[0];
        const folderPath = firstFile.webkitRelativePath.split('/');
        this.uploadedFolderName = folderPath[0]; 
    }
      
      // Reset the file input to allow re-uploading the same files
      input.value = '';
    }
  }
  
  
  
  

  importData(): void {
    this.spinner.start(); // Start spinner to indicate processing
    console.log('Import function called');
    console.log('Selected Object Group:', this.selectedObjectGroup);
    console.log('Valid Folder:', this.validFolder);

    // Check if an object group is selected
    if (!this.selectedObjectGroup) {
        this.snackbar.open('Please select an object group.', "OK", { duration: 3000 });
        this.spinner.stop();
        return;
    }

     // Check if a valid folder is selected and contains files
     if (!this.validFolder || this.files.length === 0) {
      this.snackbar.open('Please select a folder that contains at least one valid file.', "OK", { duration: 3000 });
      this.spinner.stop();
      return;
  }

    const formData = new FormData();
    this.files.forEach(file => {
        formData.append('files', file, file.name);
    });

     // Show a message that the import has started
     this.snackbar.open('Import process started. Please wait...', "OK", { duration: 3000 });
    // Call the service to import datasets
    this.spinner.stop();
    this.commonservice.ImportDatasets(this.selectedObjectGroup, formData).subscribe(
        response => {
            // Handle successful import response
            // this.snackbar.open('Import process completed successfully.', "OK", { duration: 3000 });
        },
        error => {
            // Handle error response
            this.snackbar.open('Error during import process. Please try again.', "OK", { duration: 3000 });
        },
      
    );
 
}

}
